import HeaderBar from '../../components/HeaderBar';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import MainSlider from './MainSlider';
import YoutubeLogo from './YoutubeLogo';
function HomeTab() {
  return (
    <>
      <HeaderBar />
      <Header />
      <MainSlider />
      <YoutubeLogo />
      <Footer />
    </>
  )
}

export default HomeTab
